import { render, staticRenderFns } from "./SpaceReadForm.vue?vue&type=template&id=246fb54f&scoped=true"
import script from "./SpaceReadForm.vue?vue&type=script&lang=js"
export * from "./SpaceReadForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246fb54f",
  null
  
)

export default component.exports